import request from "@libs/base/request";

export const getVoucherApi = async (params) =>
  request({
    url: "/v1/package-product",
    method: "GET",
    params,
  });

export const buyVoucherApi = async (data) =>
  request({
    url: "/v1/package-product/buy",
    method: "POST",
    data,
    tokenClient: true,
    msgSuccess: "successBuyPackage",
  });

export const getMembershipApi = async (params) =>
  request({
    url: "/v1/setting-member-card",
    method: "GET",
    params,
  });

export const buyMembershipApi = async (data) =>
  request({
    url: "/v1/member-card/buy",
    method: "POST",
    data,
    tokenClient: true,
    msgSuccess: "successBuyMembership",
  });

export const getCourseApi = async (params) =>
  request({
    url: "/api/v1/courses?per_page=999999",
    method: "GET",
    params,
    isBeUnicornAPI: true,
    tokenClient: true,
  });

export const getBoardApi = async (params) =>
  request({
    url: "/v1/product-kit",
    method: "GET",
    params,
  });

export const buyBoardApi = async (data) =>
  request({
    url: "/v1/product-kit/buy",
    method: "POST",
    data,
    tokenClient: true,
    msgSuccess: "successBuyKit",
  });

export const buyCourseApi = async (data) =>
  request({
    url: "/v1/course/buy",
    method: "POST",
    data,
    tokenClient: true,
    msgSuccess: "successBuyCourse",
  });
